import React, { createContext } from 'react';
import { AuthContextType, AuthProviderProps } from './types';
import { useAuthProvider } from './useAuthProvider';
import styles from './AuthProvider.module.css';

// デフォルト値の作成
const defaultContext: AuthContextType = {
  currentUser: null,
  loading: true,
  setCurrentUser: () => {}
};

// コンテキストの作成
export const AuthContext = createContext<AuthContextType>(defaultContext);

/**
 * 認証情報を提供するProviderコンポーネント
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  // 認証ロジックをカスタムフックから取得
  const authState = useAuthProvider();

  return (
    <AuthContext.Provider value={authState}>
      <div className={styles['auth-provider-container']}>
        {children}
      </div>
    </AuthContext.Provider>
  );
}; 